// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-menu-item, .el-submenu__title {\n  height: 40px;\n  line-height: 40px;\n}\n.el-submenu .el-menu-item {\n  height: 40px;\n  line-height: 40px;\n}\n.router-link-active {\n  color: #5697F1;\n  background-color: none;\n}\n.el-menu-item:focus,\n.el-menu-item:hover {\n  background-color: none;\n}", ""]);
// Exports
module.exports = exports;
